import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CrawfordDialogComponent, CrawfordSnackbarService, GridColumn, ITabComponent, MultiSelectFieldSettings } from 'crawford-shell';
import { ClaimService } from '../../claim/claim.service';
import { UserService } from '../../user/user.service';
import { BaseSearchListComponent } from '../base-search-list.component';
import { SavedSearch } from '../model/saved-search.model';
import { SavedSearchService } from '../saved-search.service';


@Component({
  selector: 'app-all-user-searches',
  templateUrl: './all-user-searches.component.html',
  styleUrls: ['./all-user-searches.component.scss']
})
export class AllUserSearchesComponent extends BaseSearchListComponent implements OnInit, ITabComponent {

  @ViewChild('templateCopyBtn') public templateCopyBtnRef: TemplateRef<any>;
  @ViewChild('copyDialog') public copyDialog: CrawfordDialogComponent;

  public allUsers: FormGroup;

  public selectedUserSearches: SavedSearch[] = [];
  public usersWithSavedSearch: string[] = [];

  constructor(
    router: Router,
    savedSearchService: SavedSearchService,
    snackbarService: CrawfordSnackbarService,
    activatedRoute: ActivatedRoute,
    userService: UserService,
    claimService: ClaimService,
    private formBuilder: FormBuilder
  ) {
    super (
      router,
      savedSearchService,
      snackbarService,
      activatedRoute,
      userService,
      claimService
    );
  }

  public ngOnInit() {
    super.ngOnInit();

    this.createUserSearchesForm();
    this.activatedRoute.params.subscribe(params => {
      if (params.id) {
        this.dataLoaded = false;
      }

      this.savedSearchService.getSavedSearchUsersList().subscribe(usersList => {
        if (usersList) {
          this.usersWithSavedSearch = usersList;
        }
      });
    });
  }

  protected buildGridColumns() {
    this.displayColumns = [
      new GridColumn('searchName', 'Search Description'),
      new GridColumn('lastUsedDate', 'Last Used', { type: 'date', format: this.df }),
      new GridColumn('userName', 'Username'),
      new GridColumn('copyButton', 'Copy', { template: this.templateCopyBtnRef }),
      new GridColumn('retrieveButton', 'Retrieve', { template: this.templateRetrieveBtnRef }),
      new GridColumn('deleteButton', 'Delete', { template: this.templateDeleteBtnRef })
    ];

    this.columnsToAutoFit = [ 'copyButton', 'retrieveButton', 'deleteButton' ];
  }

  public loadData(): void {
  }

  public belongsToCurrentUser(data: SavedSearch): boolean {
    return data && data.userName.toLowerCase() === this.userDetails.userName.toLowerCase();
  }

  public copySavedSearch(data: SavedSearch) {
    this.savedSearchService.getSavedSearchByName(data.searchName, this.userDetails.userName).subscribe(existingSearch => {
      if (existingSearch) {
        this.snackbarService.displayErrorMessage(
          'Failed to copy saved search, as search already exists with name \'' + data.searchName + '\'');
      } else {
        this.savedSearchService.getSavedSearchById(data.id).subscribe(search => {
          if (search) {
            this.savedSearch = search;
            this.copyDialog.showDialog();
          }
        });
      }
    });
  }

  public onCancelCopy(event: any): void {
    this.snackbarService.displayInfoMessage('Copy of saved search \'' + this.savedSearch.searchName + '\' cancelled');
  }

  public onConfirmCopy($event): void {
    this.savedSearch.userName = '';
    this.savedSearch.lastUsedDate = null;
    this.savedSearch.internal = null;
    this.savedSearchService.createSavedSearch(this.savedSearch).subscribe(created => {
      if (created) {
        this.snackbarService.displaySuccessMessage('Successfully copied saved search \'' + this.savedSearch.searchName + '\'');
        this.searchListChanged.emit();
      } else {
        this.snackbarService.displayErrorMessage('Failed to copy saved search \'' + this.savedSearch.searchName + '\'');
      }
    });
  }

  public searchForUserSearches() {
    if (this.allUsers.value.userSearches) {
      this.adaptor.setAdditionalParameters({ userNames: this.allUsers.value.userSearches });
      if (!this.dataSource) {
        this.dataSource = this.savedSearchService.getAllUsersSavedSearchDataManager(this.adaptor);
      } else {
        this.ccoGrid.search('');
      }
    }
  }

  private createUserSearchesForm(): any {
    this.allUsers = this.formBuilder.group({
      userSearches: new FormControl()
    });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/saved-search/all-user-searches/all-user-searches.component.ts